app.directive('onImageLoad', function() {
	
	return {

		restrict: 'A',

		link: function(scope, element, attrs) {
			
			element.bind("load", function(event) {

				scope.$apply(function() {
					scope.$eval(attrs.onImageLoad);
				});
				
				
			});
		},

		controller: ["$scope", "$location", "$timeout", function($scope, $location, $timeout) {


		}]
	};

});

app.directive('pathOnError', ['$timeout', function($timeout) {
	return {
		restrict: 'A',
		scope: {
			pathOnError: '@'
		},
		link: function(scope, element) {
			angular.element(element).on("error", function() {
				$timeout(function(){
					element.attr('src', scope.pathOnError);
				}, 10); // added small timeout because IE didn't like $apply for some reason
			});
		}
	};
}]);